const Colors = {
    black: '#000000',
    primaryDark: '#121212',
    primaryGreen: '#1ed760',
    primaryGray: '#b3b3b3',
    primaryLight: '#ffffff',
    secondaryDark: '#181818',
    secondaryGray: '#555555',
}

export default Colors;